<template>
  <section id="steps">
    <div class="container">
      <div class="passo-a-passo">
        <div class="passo passo1 text-center">
          <img class="img-icon" src="@/assets/icon1.png"/>
          <img class="shape shape1" src="@/assets/shape1.png"/>
          <h2>Defina o perfil da<br> sua empresa</h2>
          <p>Responda nosso questionário sobre você, adicione dados sobre a sua empresa e sobre seus concorrentes.</p>
        </div>
        <div class="passo passo2 text-center">
          <img class="img-icon" src="@/assets/icon2.png">
          <img class="shape shape2" src="@/assets/shape2.png">
          <h2>Nossos Rôbos vão<br> trabalhar</h2>
          <p>Nossa inteligência artificial irá pesquisar na Internet com base no seu perfil, os conteúdos mais relevantes e irá criar algo totalmente exclusivo.</p>
        </div>
        <div class="passo passo3 text-center">
          <img class="img-icon" src="@/assets/icon3.png">
          <h2>Revisaremos o<br> seu conteúdo</h2>
          <p>Sabemos que as máquinas são rápidas, inteligentes e tem mais processamento, mas nosso time vai tornar o trabalho da máquina incrível.</p>
        </div>
        <div class="passo passo4 text-center">
          <img class="img-icon" src="@/assets/icon4.png">
          <img class="shape shape3" src="@/assets/shape3.png">
          <h2>Publique ou<br> programe seu post</h2>
          <p>Você aprova o conteúdo criado ou pede revisão, coloca a data, horário e automaticamente o conteúdo será publicado nas suas redes sociais.</p>
        </div>
      </div>

      <div class="text-center">
        <a :href="registerLink" class="btn btn-green btn-light btn-sm mb-5">COMECE AGORA</a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['registerLink'])
  }
}
</script>
